import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const introSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="weg"
    class=${editorNodeClass(editor, 'section.intro', 'vp-section vp-intro-section')}
    style=${editorNodeStyle(editor, 'section.intro')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.intro', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.intro', event)}
  >
    <div class="vp-shell vp-intro-grid">
      ${sectionHeading({
        eyebrow: content.intro.eyebrow,
        title: content.intro.title,
        highlight: content.intro.titleHighlight,
        text: content.intro.text,
        editor,
        elementPrefix: 'intro',
      })}
      <div
        class=${editorNodeClass(editor, 'intro.metrics.container', 'vp-metrics')}
        style=${editorNodeStyle(editor, 'intro.metrics.container')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'intro.metrics.container', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'intro.metrics.container', event)}
      >
        ${content.intro.metrics.map(
          (metric, index) => html`
            <div
              class=${editorNodeClass(editor, `intro.metric.${index}`, 'vp-metric reveal-card')}
              style=${editorNodeStyle(editor, `intro.metric.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `intro.metric.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `intro.metric.${index}`, event)}
            >
              <strong
                class=${editorNodeClass(editor, `intro.metric.${index}.value`)}
                style=${editorNodeStyle(editor, `intro.metric.${index}.value`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `intro.metric.${index}.value`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `intro.metric.${index}.value`, event)}
                >${metric.value}</strong
              >
              <span
                class=${editorNodeClass(editor, `intro.metric.${index}.label`)}
                style=${editorNodeStyle(editor, `intro.metric.${index}.label`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `intro.metric.${index}.label`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `intro.metric.${index}.label`, event)}
                >${metric.label}</span
              >
            </div>
          `,
        )}
      </div>
    </div>
  </section>
`;
